import { Component, Input, inject } from "@angular/core";
import { RiskModel } from "@app/risk/models/RiskModel";
import { LinkModel } from "@models/generic/LinkModel";
import { RiskDataService } from "@app/risk/services/RiskDataService";
import { IncidentLinkModel } from "@app/incident/models/incident-link.model";
import { IncidentRisksService } from "@app/incident/services/incident-risks.service";
import { ApplicationSettings } from "@services/http/settings/application-settings";
import { SettingsDataService } from "@services/http/SettingsDataService";
import moment from "moment";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "risk-events",
    templateUrl: "./risk-events.component.html",
    styleUrls: ["./risk-events.component.scss"],
    standalone: false,
})
export class RiskEventsComponent {
    private riskDataService = inject(RiskDataService);
    private incidentRisksDS = inject(IncidentRisksService);
    private settingsDS = inject(SettingsDataService);

    @Input() model: RiskModel;

    isLoading = true;
    isLoadingIncidents = false;
    useIncidents = false;

    linked: LinkModel[];
    linkedIncidents: IncidentLinkModel[];

    async load() {
        this.useIncidents = (
            await firstValueFrom(this.settingsDS.getSetting(ApplicationSettings.UseIncidents))
        ).BoolValue;

        if (this.useIncidents) {
            this.isLoadingIncidents = true;
            this.incidentRisksDS.getLinkedIncidentsAsync(this.model.guid).subscribe((data) => {
                const mappedIncidents: IncidentLinkModel[] = [];
                if (data) {
                    data.forEach((item) => {
                        item.displayItems = [];

                        item.displayItems.push({
                            Header: "Description",
                            Value: item.description,
                        });

                        item.displayItems.push({
                            Header: "Status",
                            Value: item.status,
                        });

                        if (item.due_Date !== null && item.due_Date !== undefined) {
                            const due_Date = moment(item.due_Date).format("DD-MM-YYYY");

                            item.displayItems.push({
                                Header: "Due date",
                                Value: due_Date,
                            });
                        } else {
                            item.displayItems.push({
                                Header: "Due date",
                                Value: null,
                            });
                        }

                        if (item.date_Occurred !== null && item.date_Occurred !== undefined) {
                            const date_Occurred = moment(item.date_Occurred).format("DD-MM-YYYY");

                            item.displayItems.push({
                                Header: "Date occurred",
                                Value: date_Occurred,
                            });
                        } else {
                            item.displayItems.push({
                                Header: "Date occurred",
                                Value: null,
                            });
                        }

                        mappedIncidents.push(item);
                    });
                }
                this.linkedIncidents = mappedIncidents;
                this.isLoadingIncidents = false;
            });
        }

        this.riskDataService.getLinkedEvents(this.model.guid).subscribe((value) => {
            this.linked = value;
            this.isLoading = false;
        });
    }
}
